<template>
  <v-container>
    <v-row class="mt-4" justify="space-around">
      <v-col cols="8" sm="4">
        <h1
          class="text-center font-weight-medium text-h3 mt-6"
          style="color:#1E88E5"
        >
          Bem vindo
        </h1>
        <p
          v-if="!isCompliance"
          class="text-body-1 mt-12 font-weight-regular text-justify"
        >
          <span class="text-subtitle-1">Olá!</span> <br /><br />
          Necessitamos de participantes que tenham mais de 18 anos, todos os
          níveis educacionais, brasileiros de todas as regiões do país e queiram
          participar voluntariamente nos estudos sobre temas relevantes que as
          organizações abordam. Só serão contabilizados os testes realizados em
          computadores e concluídos até o final. Todo o ambiente é seguro e
          feito on-line dentro do nosso link, todos os dados são protegidos
          pelas diretrizes da Lei Geral de Proteção de Dados Pessoais – LGPD
          (Lei nº 13.709/2018) e com a permissão do Comitê Ético de Pesquisas.
        </p>
        <p v-else class="text-body-1 mt-12 font-weight-regular text-justify">
          <span class="text-subtitle-1">Olá!</span> <br /><br />
          O teste é todo reproduzido em um ambiente seguro e feito on-line
          dentro do nosso link. Todos os dados são protegidos pelas diretrizes
          da Lei Geral de Proteção de Dados Pessoais – LGPD(Lei nº 13.709/2018).
          Só é possível sua execução em computadores, pois, os comandos e
          funcionalidades são avançadas.
        </p>
      </v-col>
      <v-col  cols="4" sm="4">
        <p
          class="text-center font-weight-medium mt-12 text-h4 "
          style="color:#1E88E5"
        >
          Login
        </p>
        <v-form :disabled="true" ref="form" class="mt-12" v-model="valid" lazy-validation>
          <v-alert v-if="error" class="mb-6" dense outlined type="error">
            <small>Verifique se os dados estão corretos.</small>
          </v-alert>
          <v-text-field
            class="font-weight-bold"
            v-on:click="resetForm"
            v-model.trim="email"
            :rules="emailRules"
            placeholder="E-mail"
            label="E-mail"
            outlined
            required
          ></v-text-field>
          <v-text-field
            :type="show1 ? 'text' : 'password'"
            class="mt-2 mb-0 font-weight-bold"
            :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
            v-model.trim="password"
            :rules="passwordRules"
            placeholder="Senha"
            label="Senha"
            @click:append="show1 = !show1"
            v-on:click="resetForm"
            outlined
            required
          ></v-text-field>
          <v-btn
            :disabled="true"
            color="#1E88E5"
            block
            class="mt-4 font-weight-bold white--text"
            @click="validate"
            >Entrar</v-btn
          >
          <v-row class="text-center" justify="end">
            <v-col>
              <v-btn
                text
                color="#1E88E5"
                class="px-0 ml-auto mt-4"
                @click="forgotPassword"
                :disabled="true"
                >Esqueci a senha</v-btn
              >
            </v-col>
          </v-row>
        </v-form>
        <!--
        <v-row class="mt-10" align="center" justify="center">
          <span class="subtitle px-0 font-weight-regular float-right text-h6"
            >Não tem conta?</span
          >
          <v-btn
            dark
            class="ml-2 font-weight-bold"
            color="#1E88E5"
            depressed
            small
            disabled="true"
            @click="newUser"
            >Criar conta</v-btn
          >
        </v-row> -->
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-dialog v-model="forgotPasswordDialog" persistent max-width="360">
        <v-card>
          <v-card-title style="color: #1E88E5" class="headline"
            >Redefinir senha</v-card-title
          >
          <v-card-text class="font-weight-bold">Insira seu email</v-card-text>
          <v-form
          :disabled="true"
            ref="forgotPasswordForm"
            v-model="forgotPasswordValid"
            lazy-validation
            class="mx-2"
          >
            <v-card-text>
              <v-text-field
                class="font-weight-bold"
                v-model.trim="forgotEmail"
                :rules="emailRules"
                placeholder="E-mail"
                label="E-mail"
                required
              ></v-text-field>
            </v-card-text>
          </v-form>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="#1E88E5"
              class="px-4"
              outlined
              @click="backButtonForgotPassword"
              >Voltar</v-btn
            >
            <v-btn
              class="white--text px-4"
              color="#1E88E5"
              @click="validateForgotPasswordEmail"
              >Confirmar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <div class="text-center">
      <v-bottom-sheet v-model="bottomSheet" persistent>
        <v-sheet class="text-center" height="200px">
          <div width="100px" class="py-3 pt-8 px-6">
            Enviamos um email com instruções para redefinir sua senha
          </div>
          <v-btn
            class="mt-6"
            color="primary"
            @click="bottomSheet = !bottomSheet"
            >Entendi</v-btn
          >
        </v-sheet>
      </v-bottom-sheet>
    </div>
    <div class="text-center">
      <v-bottom-sheet v-model="bottomSheetCompletedTest" persistent>
        <v-sheet class="text-center" height="200px">
          <div width="100px" class="py-3 pt-8 px-6">
            Você já participou dos estudos, obrigado.<br />
            Indique alguém para participar também:
            <a
              href="https://teste.topethic.com.br "
              class="text-decoration-none"
              >https://teste.topethic.com.br
            </a>
          </div>
          <v-btn class="mt-6" color="primary" @click="closeCompletedTestModal"
            >Entendi</v-btn
          >
        </v-sheet>
      </v-bottom-sheet>
    </div>
  </v-container>
</template>

<script>
import { router } from "../router";

export default {
  name: "LoginDisabled",
  data: () => ({
    bottomSheet: false,
    bottomSheetCompletedTest: false,
    forgotPasswordDialog: false,
    forgotEmail: "",
    formError: false,
    valid: true,
    forgotPasswordValid: true,
    show1: false,
    error: false,
    email: "",
    emailRules: [
      (v) => !!v || "E-mail é obrigatório",
      (v) => /.+@.+\..+/.test(v) || "E-mail precisa ser válido",
    ],
    password: "",
    passwordRules: [(v) => !!v || "A senha é obrigatória"],
  }),
  mounted() {
    this.bottomSheetCompletedTest = this.$route.query?.completed_test;
  },
  computed: {
    isCompliance() {
      return this.$route.query.t && this.$route.query.t === "compliance";
    },
  },
  methods: {
    validate() {
      if (this.$refs.form.validate()) this.login();
    },
    login() {
      this.$store
        .dispatch("login", {
          email: this.email,
          password: this.password,
        })
        .then((data) => {
          if (data.completed_test) {
            this.bottomSheetCompletedTest = true;
          } else {
            router.push({ name: "Home" }).catch((error) => {});
          }
        })
        .catch((error) => {
          this.error = true;
        });
    },
    forgotPassword() {
      this.forgotPasswordDialog = true;
      this.forgotPasswordValid = true;
    },
    validateForgotPasswordEmail() {
      if (this.$refs.forgotPasswordForm.validate()) {
        this.sendForgotPasswordEmail();
      }
    },
    sendForgotPasswordEmail() {
      this.forgotPasswordDialog = false;
      this.bottomSheet = true;
      this.$store.dispatch("forgotPassword", { email: this.forgotEmail });
    },
    backButtonForgotPassword() {
      this.forgotPasswordDialog = false;
    },
    newUser() {
      //const query = this.$route.query.t !== 'compliance' ? {} : {t: 'compliance'}
      router.push({ name: "Signup", query: this.$route.query });
    },
    resetForm(event) {
      this.error = false;
    },
    closeCompletedTestModal() {
      this.bottomSheetCompletedTest = false;
      const query = {};
      if (this.$route.query && this.$route.query.t) {
        query.t = this.$route.query.t;
      }
      router.replace({ name: "Login", query });
    },
  },
};
</script>
